/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Eyebrow_RelatedInputs */

const en_directory_ai_tools_eyebrow_related = /** @type {(inputs: Directory_Ai_Tools_Eyebrow_RelatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternatives`)
};

const zh_directory_ai_tools_eyebrow_related = /** @type {(inputs: Directory_Ai_Tools_Eyebrow_RelatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同类工具`)
};

/**
* | output |
* | --- |
* | "Alternatives" |
*
* @param {Directory_Ai_Tools_Eyebrow_RelatedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_eyebrow_related = /** @type {((inputs?: Directory_Ai_Tools_Eyebrow_RelatedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Eyebrow_RelatedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_eyebrow_related(inputs)
	return zh_directory_ai_tools_eyebrow_related(inputs)
});
export { directory_ai_tools_eyebrow_related as "directory.ai_tools.eyebrow.related" }